export default "__VITE_PUBLIC_ASSET__b71a6226__"